import React, { useMemo, useState } from "react";
import { formatCurrency } from "../../../utils/helpers";


const Card = ({severity, label, subtext, value, icon, loading}) => {
    const formateador = new Intl.NumberFormat('en-US');

    return  <div className="col-12 col-md d-flex align-items-center">
        <div className={`badge badge-${severity} badge-light p-3`} style={{fontSize: '1.5rem', borderRadius: '5px'}}>
            <i class={icon}></i>
        </div>

        <div className="ml-2 col">
            {loading ? <span className="text-muted">Cargando...</span> : <span className={`text-${severity}`} style={{fontSize: '1.15rem', fontWeight: 500}}>{formateador.format(value)}</span>}
            {!loading && <div style={{fontWeight: 600, fontSize: '0.8rem'}}>{label}</div>}
            {!loading && <div className="text-muted" style={{fontSize: '0.7rem'}}>{subtext}</div>}
        </div>
    </div>;
};

const DespachoSummary = ({ summary, loading }) => {
    const porcentajes = useMemo(() => {
        if (loading || !summary?.total_facturas) return null;

        return {
            porcentajePorCargar: (summary?.total_por_cargar / summary?.total_facturas) * 100,
            porcentajeCargadas: (summary?.total_cargadas / summary?.total_facturas) * 100,

            porcentajePorEntregar: (summary?.total_por_entregar / summary?.total_facturas) * 100,
            porcentajeEntregadas: (summary?.total_entregadas / summary?.total_facturas) * 100,
        };
    }, [loading, summary]);
    
    return <div className="row">
        <Card severity="success" label="Total Facturas" subtext="En el periodo seleccionado" value={summary?.total_facturas || 0} icon="far fa-file-alt" loading={loading} />
        
        <Card severity="info" label="Por Cargar" subtext={porcentajes ? `${porcentajes.porcentajePorCargar.toFixed(1)}% del total` : null} value={summary?.total_por_cargar || 0} icon="fas fa-truck-loading" loading={loading} />
        <Card severity="help" label="Cargado" subtext={porcentajes ? `${porcentajes.porcentajeCargadas.toFixed(1)}% del total` : null} value={summary?.total_cargadas || 0} icon="fas fa-truck" loading={loading} />
        
        <Card severity="warning" label="Por Entregar" subtext={porcentajes ? `${porcentajes.porcentajePorEntregar.toFixed(1)}% del total` : null} value={summary?.total_por_entregar || 0} icon="fas fa-boxes" loading={loading} />
        <Card severity="primary" label="Entregados" subtext={porcentajes ? `${porcentajes.porcentajeEntregadas.toFixed(1)}% del total` : null} value={summary?.total_entregadas || 0} icon="far fa-check-circle" loading={loading} />
    </div>;
};

export default DespachoSummary;